import "./MultiQtyCell.css";
import RenderSvg from "../renderSvg/RenderSvg";
import { Row } from "../../features/claimsNew/utils/CreateClaimUtils";
import { Divider } from "@mui/material";
import { Underline } from "tabler-icons-react";

interface MultiQtyCellProps {
  pcQty: number;
  csQty: number;
  otherQty?: number;
  hasEditButton?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  rowData?: any;
  setSelectedRowToEdit?: React.Dispatch<React.SetStateAction<Row | null>>;
  handleClickEdit?: any;
  handleClickEditPurchaseReturnsRow?: any;
  insidePurchaseReturns?: boolean;
  viewprimaryorderconfigs?:boolean;
  singleQtyUom?: string;
  otherUnitName?: string;
  isStockExceeded?: boolean;
  insideManageOrder?:boolean;
  alignLeft?:boolean;
  addDividers?:boolean
  highlightBorder?: string;
}

const MultiQtyCell: React.FC<MultiQtyCellProps> = ({
  pcQty = 0,
  csQty = 0,
  otherQty = 0,
  hasEditButton,
  handleClickEdit,
  handleClickEditPurchaseReturnsRow,
  insidePurchaseReturns,
  viewprimaryorderconfigs,
  singleQtyUom,
  otherUnitName,
  isStockExceeded,
  insideManageOrder,
  alignLeft,
  addDividers,
  highlightBorder
}) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const { caseUnitLabel, otherUnitLabel, packUnitLabel,packUnitLabelPrimary,caseUnitLabelPrimary, otherUnitLabelPrimary, designationBasedUomSecondary, displayOtherUnitName, manageSecondaryOrderV2} = ConfigDictionary;

  let customOtherUnitLabelOuter = displayOtherUnitName
    ? (otherUnitName && otherUnitName.length > 0 ? otherUnitName : otherUnitLabel)
    : otherUnitLabel;

  if (singleQtyUom) {
    let caseUnit, otherUnit, packUnit
    if (viewprimaryorderconfigs){
      caseUnit = caseUnitLabelPrimary
      packUnit = packUnitLabelPrimary
      otherUnit = otherUnitLabelPrimary
    } else{
      caseUnit = caseUnitLabel
      packUnit = packUnitLabel
      otherUnit = otherUnitLabel
    }
    let customOtherUnitLabel = displayOtherUnitName
      ? (otherUnitName && otherUnitName.length > 0 ? otherUnitName : otherUnit)
      : otherUnit;

    return (<div className="MultiQtyCell_root">
      <div
        className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_parent_containerV2": "MultiQtyCell_parent_container"} ${isStockExceeded ? "quantity-stock-exceed" : ""}`}
        style={highlightBorder ? { border: `1px solid ${highlightBorder}` } : undefined}
      >
        
        {caseUnit && (singleQtyUom === caseUnit) && (
        <div className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_child_containerV2":"MultiQtyCell_child_container"}`}>
          <div className="MultiQtyCell_qty">{csQty}</div>
          <div className="MultiQtyCell_label">{caseUnit}</div>
        </div>
      )}
        {otherUnit && (singleQtyUom === otherUnit) && (
          <div className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_child_containerV2":"MultiQtyCell_child_container"}`}>
            <div className="MultiQtyCell_qty">{otherQty}</div>
            <div className="MultiQtyCell_label">{customOtherUnitLabel}</div>
          </div>
        )}
        {packUnit && (singleQtyUom === packUnit) && (
        <div className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_child_containerV2":"MultiQtyCell_child_container"}`}>
          <div className="MultiQtyCell_qty">{pcQty}</div>
          <div className="MultiQtyCell_label">{packUnit}</div>
        </div>
    )}
        {isStockExceeded && <div className="multiQty-disclaimer">
          <RenderSvg name="disclaimerIcon" customStyles={{color: "#B54747", height: "11px", width: "11px"}}/>
        </div>}
      </div>
    </div>
    )
  }

  if(viewprimaryorderconfigs){
    let customOtherUnitLabel = displayOtherUnitName
      ? (otherUnitName && otherUnitName.length > 0 ? otherUnitName : otherUnitLabelPrimary)
      : otherUnitLabelPrimary;
     return (
    <div className="MultiQtyCell_root">
      <div
        className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_parent_containerV2": "MultiQtyCell_parent_container"} ${otherUnitLabelPrimary ? "MultiQtyCell_3_uom" : ""} ${isStockExceeded ? "quantity-stock-exceed" : ""}`}
      >
        {caseUnitLabelPrimary && (
        <div className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_child_containerV2":"MultiQtyCell_child_container"}`}>
          <div className="MultiQtyCell_qty">{csQty}</div>
          <div className="MultiQtyCell_label">{caseUnitLabelPrimary}</div>
        </div>
      )}
        {addDividers && otherUnitLabelPrimary && <Divider
          style={{
            padding: "10px 0",
            borderRight: "2px dotted",
            color: "#DFE2E7",
            margin: "0 5px",
            height: "12px",
            alignSelf: "center",
            boxSizing: "border-box",
          }}
          orientation="vertical"
          flexItem
        />}
        {otherUnitLabelPrimary && (
          <div className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_child_containerV2":"MultiQtyCell_child_container"}`}>
            <div className="MultiQtyCell_qty">{otherQty}</div>
            <div className="MultiQtyCell_label">{customOtherUnitLabel}</div>
          </div>
        )}
        {addDividers && packUnitLabelPrimary && <Divider
          style={{
            padding: "10px 0",
            borderRight: "2px dotted",
            color: "#DFE2E7",
            margin: "0 5px",
            height: "12px",
            alignSelf: "center",
            boxSizing: "border-box",
          }}
          orientation="vertical"
          flexItem
        />}
        {packUnitLabelPrimary && (
        <div className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_child_containerV2":"MultiQtyCell_child_container"}`}>
          <div className="MultiQtyCell_qty">{pcQty}</div>
          <div className="MultiQtyCell_label">{packUnitLabelPrimary}</div>
        </div>
    )}
    {isStockExceeded && <div className="multiQty-disclaimer">
          <RenderSvg name="disclaimerIcon" customStyles={{color: "#B54747", height: "11px", width: "11px"}}/>
        </div>}
      </div>
      {hasEditButton ? (
        <button
          className="MultiQtyCell_edit-button"
          onClick={insidePurchaseReturns ? handleClickEditPurchaseReturnsRow : handleClickEdit}
        >
          <RenderSvg name={"viewAndEditIcon"} />
        </button>
      ) : (
        <></>
      )}
    </div>
  );
  }

  const designationEnabled  =  designationBasedUomSecondary?.enable ?? false;
  const availableDesignations = designationBasedUomSecondary?.roles?.designationKeys?.map(((item: { type: any; }) => item?.type)) || [];
  const currentDesignation = JSON.parse(localStorage.authContext).user.designation || [];
  const designation = availableDesignations.find((type: any) => 
    currentDesignation.includes(type)
  );
  const designationKeys = designationBasedUomSecondary?.roles?.designationKeys ?? [];
  const matchedRole = designationKeys.find((role: { type: string; uomAllowed: any }) => role.type === designation);

  if(designationEnabled && designation && designationKeys && matchedRole){
    return (
      <div className="MultiQtyCell_root">
        <div
          className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_parent_containerV2": "MultiQtyCell_parent_container"} ${otherUnitLabel ? "MultiQtyCell_3_uom" : ""}  ${isStockExceeded ? "quantity-stock-exceed" : ""} `}
          style={highlightBorder ? { border: `1px solid ${highlightBorder}` } : undefined}
        >
          {matchedRole.uomAllowed.case?.trim() && (<div className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_child_containerV2":"MultiQtyCell_child_container"} ${alignLeft ? "alignLeft" : ""}`}>
            <div className="MultiQtyCell_qty">{csQty}</div>
            <div className="MultiQtyCell_label">{caseUnitLabel}</div>
          </div>)}
  
          
  
          {matchedRole.uomAllowed.piece?.trim() && (<div className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_child_containerV2":"MultiQtyCell_child_container"} ${alignLeft ? "alignLeft" : ""}`}>
            <div className="MultiQtyCell_qty">{pcQty}</div>
            <div className="MultiQtyCell_label">{packUnitLabel}</div>
          </div>)}
          {isStockExceeded && <div className="multiQty-disclaimer">
            <RenderSvg name="disclaimerIcon" customStyles={{color: "#B54747", height: "11px", width: "11px"}}/>
          </div>}
        </div>
        {hasEditButton ? (
          <button
            className="MultiQtyCell_edit-button"
            onClick={insidePurchaseReturns ? handleClickEditPurchaseReturnsRow : handleClickEdit}
          >
            <RenderSvg name={"viewAndEditIcon"} />
          </button>
        ) : (
          <></>
        )}
      </div>
    );
  }

  return (
    <div className="MultiQtyCell_root">
      <div
        className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_parent_containerV2": "MultiQtyCell_parent_container"} ${otherUnitLabel ? "MultiQtyCell_3_uom" : ""}  ${isStockExceeded ? "quantity-stock-exceed" : ""} `}
        style={highlightBorder ? { border: `1px solid ${highlightBorder}` } : undefined}
      >
        {caseUnitLabel && (
        <div className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_child_containerV2":"MultiQtyCell_child_container"} ${alignLeft ? "alignLeft" : ""}`}>
          <div className="MultiQtyCell_qty">{csQty}</div>
          <div className="MultiQtyCell_label">{caseUnitLabel}</div>
        </div>
        )}
        {addDividers && otherUnitLabel && <Divider
          style={{
            padding: "10px 0",
            borderRight: "2px dotted",
            color: "#DFE2E7",
            margin: "0 5px",
            height: "12px",
            alignSelf: "center",
            boxSizing: "border-box",
          }}
          orientation="vertical"
          flexItem
        />}
        {otherUnitLabel && (
          <div className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_child_containerV2":"MultiQtyCell_child_container"} ${alignLeft ? "alignLeft" : ""}`}>
            <div className="MultiQtyCell_qty">{otherQty}</div>
            <div className="MultiQtyCell_label">{customOtherUnitLabelOuter}</div>
          </div>
        )}
        {addDividers && packUnitLabel && <Divider
          style={{
            padding: "10px 0",
            borderRight: "2px dotted",
            color: "#DFE2E7",
            margin: "0 5px",
            height: "12px",
            alignSelf: "center",
            boxSizing: "border-box",
          }}
          orientation="vertical"
          flexItem
        />}
        {packUnitLabel && (
        <div className={`${(manageSecondaryOrderV2 && insideManageOrder) ? "MultiQtyCell_child_containerV2":"MultiQtyCell_child_container"} ${alignLeft ? "alignLeft" : ""}`}>
          <div className="MultiQtyCell_qty">{pcQty}</div>
          <div className="MultiQtyCell_label">{packUnitLabel}</div>
        </div>
        )}
        {isStockExceeded && <div className="multiQty-disclaimer">
          <RenderSvg name="disclaimerIcon" customStyles={{color: "#B54747", height: "11px", width: "11px"}}/>
        </div>}
      </div>
      {hasEditButton ? (
        <button
          className="MultiQtyCell_edit-button"
          onClick={insidePurchaseReturns ? handleClickEditPurchaseReturnsRow : handleClickEdit}
        >
          <RenderSvg name={"viewAndEditIcon"} />
        </button>
      ) : (
        <></>
      )}
    </div>
  );
};

export default MultiQtyCell;
